export default "__VITE_ASSET__ab37858c__"